import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_CATEGORIES_REQUEST: 'FETCH_CATEGORIES_REQUEST',
    FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_FAILURE: 'FETCH_CATEGORIES_FAILURE'
};

/**
 * ActionCreator pour FETCH_CATEGORIES_REQUEST
 */
const fetchCategoriesRequest = () => ({ type: Actions.FETCH_CATEGORIES_REQUEST });

/**
 * ActionCreator pour FETCH_CATEGORIES_SUCCESS
 */
const fetchCategoriesSuccess = categories => ({ type: Actions.FETCH_CATEGORIES_SUCCESS, categories });

/**
 * ActionCreator pour FETCH_CATEGORIES_FAILURE
 */
const fetchCategoriesFailure = error => ({ type: Actions.FETCH_CATEGORIES_FAILURE, error });

/**
 * ActionCreator pour la récupération des catégories
 */
export const fetchCategories = () => (dispatch, getState) => {
    if (getState().categorie.categories.isLoading) {
        return;
    }
    if (getState().categorie.categories.items.length > 0) {
        return;
    }
    return dispatch(_fetchCategories());
};

export const _fetchCategories = () => async (dispatch) => {
    dispatch(fetchCategoriesRequest());

    try {
        let response = await axios.get('api/categories');

        dispatch(fetchCategoriesSuccess(response.data));

    } catch (error) {
        dispatch(fetchCategoriesFailure(error));
    }
};
